const asText = (value) => value === null || value === undefined ? '' : String(value);
const isUnsignedInteger = (value) => /^\d+$/.test(asText(value));

export function validateRequisiteForm({
    formData,
    availablePayments = [],
    isSbp = false,
    isLast4digitsRequired = false,
    isIbanRequired = false,
}) {
    if (availablePayments.length === 0) return 'noPaymentMethodsAssigned';
    if (!formData.payment_type) return 'paymentMethodRequired';
    if (!availablePayments.some((payment) => String(payment[1]) === String(formData.payment_type))) {
        return 'paymentMethodUnavailable';
    }
    if (!asText(formData.credentials).trim()) return 'credentialsRequired';
    if (asText(formData.credentials).trim().length > 150) return 'credentialsTooLong';
    if (!isUnsignedInteger(formData.credentials_limit)) return 'limitRequired';
    if (Number(formData.credentials_limit) > 50000000) return 'limitTooHigh';
    if (!formData.status) return 'statusRequired';
    if (!isUnsignedInteger(formData.min_rur)) return 'minAmountRequired';
    if (!isUnsignedInteger(formData.max_rur)) return 'maxAmountRequired';
    if (Number(formData.min_rur) > 20000) return 'minAmountTooHigh';
    if (Number(formData.min_rur) > Number(formData.max_rur)) return 'minGreaterThanMax';
    if (isSbp && !formData.kind) return 'bankRequired';
    if (isSbp && !asText(formData.recipient).trim()) return 'recipientRequired';
    if (isLast4digitsRequired && !/^\d{4}$/.test(asText(formData.last4digits))) {
        return 'last4digitsInvalid';
    }
    if (isIbanRequired && !/^\d{4}$/.test(asText(formData.iban_last4digits))) {
        return 'ibanLast4digitsInvalid';
    }
    if (formData.can_autoclose && !asText(formData.device_id).trim()) return 'deviceCodeRequired';
    return null;
}

function flattenMessages(value) {
    if (Array.isArray(value)) return value.flatMap(flattenMessages);
    if (value && typeof value === 'object') return Object.values(value).flatMap(flattenMessages);
    if (value === null || value === undefined || value === '') return [];
    return [String(value)];
}

export function formatApiErrors(payload, fieldNames = {}, fallback = '') {
    if (!payload) return fallback;
    if (typeof payload === 'string') return payload;

    const preferred = payload.detail || payload.text || payload.error || payload.message;
    if (preferred) return flattenMessages(preferred).join('\n') || fallback;

    const lines = Object.entries(payload).flatMap(([field, value]) => {
        const messages = flattenMessages(value);
        if (messages.length === 0) return [];
        const label = fieldNames[field] || (field === 'non_field_errors' ? fieldNames.__all__ : field);
        return [`${label || field} - ${messages.join('\n')}`];
    });
    return lines.join('\n') || fallback;
}
